import React, { useEffect, useState } from "react";
import "./LogsPage.scss";
import { allActivityAction, fetchUserSpentTime } from "../../../redux/action/activity";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../redux/hooks";
import { actionGetUsers } from "../../../redux/action/user";
import ActivityTypePlot from "./ActivityTypePlot";
import ActivityPeriodPlot from "./ActivityPeriodPlot";
import LastActivityPlot from "./LastActivityPlot";
import Plot from "react-plotly.js";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const LogsPage: React.FC = () => {
  const dispatch = useDispatch();

  // Access activities and users from Redux store
  const activities = useAppSelector((state) => state.activity.allActivities);
  const userList = useAppSelector((state) => state.user.userList);
  const spentTimePerUser = useAppSelector((state) => state.activity.spentTime)
  const allUserLastActivity = useAppSelector((state) => state.activity.allActivities?.allUserLastActivity)
  const userWithIpAddress = useAppSelector((state) => state.activity.allActivities?.userdata?.data)
  const hoursOnEachPageByUser = useAppSelector((state) => state.activity.allActivities?.hoursOnEachPageByUser)
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);
  const [selectedActivityType, setSelectedActivityType] = useState<string>("");
  const [selectedUser, setSelectedUser] = useState<string>("");
  const [selectedUserWithIpAddress, setSlectedUserWithIpAddress] = useState<string>("");
  const [userSearch, setUserSearch] = useState<string>(""); // for input search
  const [filteredUsers, setFilteredUsers] = useState<any[]>([]); // to store filtered user suggestions
  const [ActivityType, setActivityType] = useState<string[]>([]);
  const [ActivityTime, setActivityTime] = useState<number[]>([]);
  const [ActivityUser, setActivityUser] = useState<string>("");
  const [ActivityTotalTimeLabel, setActivityTotalTimeLabel] = useState<string[]>([]);
  const [ActivityTotalTime, setActivityTotalTime] = useState<number[]>([]);
  const [ActivityGapLabel, setActivityGapLabel] = useState<string[]>([]);
  const [ActivityGap, setActivityGap] = useState<number[]>([]);

  // State for the start and end date filters
  const [startDate, setStartDate] = useState<string>(getDefaultStartDate());
  const [endDate, setEndDate] = useState<string>(getDefaultEndDate());

  // Function to get default start date (30 days ago)
  function getDefaultStartDate() {
    const date = new Date();
    date.setDate(date.getDate() - 30); // 30 days ago
    return date.toISOString().split("T")[0];
  }

  // Function to get default end date (current date)
   // Function to get default end date (current date)
   function getDefaultEndDate() {
     const date = new Date();
    //  date.setDate(date.getDate() + 1);
     return date.toISOString().split("T")[0];
   }

  // Fetch users and activities based on filters when dependencies change
  useEffect(() => {
    dispatch(actionGetUsers() as any);
    // Check if startDate and endDate are valid
    const validStartDate = startDate ? new Date(startDate) : undefined;
    const validEndDate = endDate ? new Date(endDate) : undefined;
    // Dispatch the action with both startDate and endDate
    dispatch(allActivityAction(currentPage, itemsPerPage, selectedActivityType, selectedUser, validStartDate, validEndDate) as any);
  }, [dispatch, currentPage, selectedActivityType, selectedUser, startDate, endDate]); // Include endDate in dependencies

  useEffect(() => {
    if (userWithIpAddress && userWithIpAddress.length > 0) {
      setActivityUser(userWithIpAddress[0].email + ' (' + userWithIpAddress[0].ipAddress + ')');
      dispatch(fetchUserSpentTime(userWithIpAddress[0].userId, userWithIpAddress[0].ipAddress) as any);
      setSlectedUserWithIpAddress(JSON.stringify(userWithIpAddress[0]));
      const userActivityIdentifiers = allUserLastActivity?.map((user:any) => `${user.email}<br>(${user.ipAddress})`) || [];
      const userActivityDays = allUserLastActivity?.map((user:any) => user.days) || [];
      setActivityGapLabel(userActivityIdentifiers);
      setActivityGap(userActivityDays);  
    }
  }, [userWithIpAddress]);
  
  useEffect(() => {
    if (userWithIpAddress && userWithIpAddress.length > 0) {
      const spentTimePerUsers = spentTimePerUser?.activityTime;
      // Convert activity values to seconds for chart calculation, and prepare labels in HH:MM:SS
      const activityLabels = Object.keys(spentTimePerUsers || {});
      const activityValues = Object.values(spentTimePerUsers || {}).map((time) =>
        typeof time === "string" ? convertToSeconds(time) : 0
      );
      // Format the labels as HH:MM:SS
      const formattedLabels = activityLabels.map((label, index) => {
        const timeInSeconds = activityValues[index];
        const formattedTime = convertToHHMMSS(timeInSeconds); // Convert seconds to HH:MM:SS format
        return `${label} - ${formattedTime}`;
      });
      setActivityType(formattedLabels);
      setActivityTime(activityValues);  
console.log('user', userWithIpAddress);
      const userIdentifiers = hoursOnEachPageByUser?.map((user:any) => `${user.email}<br>(${user.ipAddress})`) || [];
      const userHours = hoursOnEachPageByUser?.map((user:any) => (user.totalMinutes / 60.0)) || [];
      setActivityTotalTimeLabel(userIdentifiers);
      setActivityTotalTime(userHours);
    }
  }, [spentTimePerUser, spentTimePerUser?.activityTime]);
  
  // Function to filter users based on search input
  const handleUserSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value;
    setUserSearch(searchValue);

    // Filter users based on the typed email
    const filtered = userList.filter((user: any) =>
      user.email.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredUsers(filtered);
  };

  // Handler for user selection from suggestions
  const handleUserSelect = (userId: string, email: string) => {
    setSelectedUser(userId);
    setUserSearch(email);
    setCurrentPage(1);
    setFilteredUsers([]); // Clear suggestions once a user is selected
  };

  // Function to handle the Enter key press
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearchClick();
      setCurrentPage(1);
    }
  };

  // Handler for search logic (from keyboard Enter key press)
  const handleSearchClick = () => {
    const validStartDate = startDate ? new Date(startDate) : undefined;
    const validEndDate = endDate ? new Date(endDate) : undefined;

    if (userSearch.trim() === "") {
      setSelectedUser(""); // Reset the selected user if the search input is empty
      dispatch(allActivityAction(currentPage, itemsPerPage, selectedActivityType, "", validStartDate, validEndDate) as any);
    } else {
      const selectedUserId = userList.find((user: any) => user.email.toLowerCase() === userSearch.toLowerCase())?._id || "";
      setSelectedUser(selectedUserId); // Set selected user
      dispatch(allActivityAction(currentPage, itemsPerPage, selectedActivityType, selectedUserId, validStartDate, validEndDate) as any);
    }
  };

  // List of activity types for the dropdown
  const activityTypes = [
    "Map", "Home", "Status", "EventReportDownload", "User", "Event", "Help", "Notification", "LoggedIn", "LoggedOut"
  ];

  // Pagination logic
  const indexOfLastLog = currentPage * itemsPerPage;
  const indexOfFirstLog = indexOfLastLog - itemsPerPage;

  // Get total number of activities directly from the activities object
  const totalActivities = activities?.totalActivities || 0;

  // Calculate total pages based on totalActivities
  const totalPages = selectedActivityType || selectedUser || startDate || endDate
    ? Math.ceil(totalActivities / itemsPerPage)
    : Math.ceil(totalActivities / itemsPerPage);

  // Handler for page navigation
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  const renderPaginationPages = () => {
    const pages: (number | string)[] = [];

    if (totalPages <= 3) {
      // If there are only 3 or fewer pages, show them all
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Only add the first page if the current page is not 1
      if (currentPage > 1) {
        pages.push(1);
      }

      // Show ellipsis if the current page is not near the start and the current page is not 2
      if (currentPage > 2) {
        pages.push("...");
      }

      // Show Current Page
      pages.push(currentPage);

      // Show ellipsis if the current page is not near the end
      if (currentPage < totalPages - 1) {
        pages.push("...");
      }

      // Only add the last page if the current page is not the last page
      if (currentPage < totalPages) {
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const calculateTimeDifference = (startTime: Date, endTime: Date | null) => {
    if (!endTime) {
      return "-";
    }

    const diffInMs = endTime.getTime() - startTime.getTime();
    const hours = Math.floor(diffInMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffInMs % (1000 * 60)) / 1000);

    if (hours === 0 && minutes === 0) {
      return `${seconds}s`;
    } else if (hours === 0) {
      return `${minutes}m ${seconds}s`;
    } else {
      return `${hours}h ${minutes}m ${seconds}s`;
    }
  };

  // Prepare data for the Pie Chart
  // Function to convert "HH:MM:SS" to total seconds
  const convertToSeconds = (time: string): number => {
    const [hours, minutes, seconds] = time.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  };

  // Function to convert total seconds to "HH:MM:SS"
  const convertToHHMMSS = (seconds: number): string => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  const handleUserChange = (userString: string) => {
    if (userString === "") {
        return;
    }
    const user = JSON.parse(userString);
    setActivityUser(user.email + ' (' + user.ipAddress + ')');
    dispatch(fetchUserSpentTime(user.userId, user.ipAddress) as any);
    setSlectedUserWithIpAddress(userString);   
  };
  
  return (
    <div className="logs-container">
      <div className="charts-container">
        <Table><TableBody><TableRow>
          <TableCell style={{border: '1px solid rgba(255, 255, 255, 1)', width: '30%'}}>
            <div className="chart-container pie-chart">
              <ActivityTypePlot user={ActivityUser} activityType={ActivityType} activityTime={ActivityTime}/>
            </div>
            <div className="user-dropdown-container">
              <label htmlFor="user-dropdown">Select User:</label>
              <select
                id="user-dropdown"
                value={selectedUserWithIpAddress}
                onChange={(e) => handleUserChange(e.target.value)}
              >
                {userWithIpAddress?.map((user: any) => (
                  <option key={user.email} value={JSON.stringify(user)}>
                    {user.email}&nbsp;&nbsp;({user.ipAddress})
                  </option>
                ))}
              </select>
            </div>
          </TableCell>
          <TableCell style={{border: '1px solid rgba(255, 255, 255, 1)', width: '30%'}}>  
            <div className="bar-chart-container user-chart">
              <ActivityPeriodPlot user={ActivityTotalTimeLabel} period={ActivityTotalTime}/>
            </div>
          </TableCell>
          <TableCell style={{border: '1px solid rgba(255, 255, 255, 1)', width: '30%'}}>  
            <div className="bar-chart-container user-activity-chart">
              <LastActivityPlot user={ActivityGapLabel} gap={ActivityGap}/>
            </div>
          </TableCell>  
        </TableRow></TableBody></Table>
      </div>
    
      <h2 className="logs-title">Activity Logs</h2>
      <div className="filter-all-container">
        {/* Filter by Activity Type */}
        <div className="filter-container">
          <label htmlFor="activity-type">Activity Type:</label>
          <select
            id="activity-type"
            value={selectedActivityType}
            onChange={(e) => {
              setSelectedActivityType(e.target.value);
              setCurrentPage(1); // Reset to first page when changing filter
            }}
          >
            <option value="">All Activity Types</option>
            {activityTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {/* Filter by User */}
        <div className="filter-container">
          <label htmlFor="user">User:</label>
          <input
            id="user"
            type="text"
            value={userSearch}
            onChange={handleUserSearch}
            onKeyPress={handleKeyPress}  // Attach the Enter key press event
            placeholder="Search by email"
          />
          {userSearch && filteredUsers.length > 0 && (
            <div className="suggestions-list">
              {filteredUsers.map((user) => (
                <div
                  key={user._id}
                  className="suggestion-item"
                  onClick={() => handleUserSelect(user._id, user.email)}
                >
                  {user.email}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Filter by Start Date */}
        <div className="filter-container">
          <label>Date:</label>
          <input
            id="start-date"
            type="date"
            value={startDate}
            onChange={(e) =>{ setStartDate(e.target.value);
              setCurrentPage(1);}}
          />
        </div>
          {/* <div className="filter-container">To</div> */}
        {/* Filter by End Date */}
        <div className="filter-container">
          <label>To:</label>
          <input
            id="start-date"
            type="date"
            value={endDate}
            onChange={(e) =>{ setEndDate(e.target.value);
              setCurrentPage(1);
            }} // Set the endDate value when changed
          />
        </div>
      </div>

      <div className="logs-table-container">
        <table className="logs-table">
          <thead>
            <tr>
              <th>Serial No.</th>
              <th>User</th>
              <th>Date & Time</th>
              <th>Time Spent</th>
              <th>Activity Type</th>
              <th>IP</th>
              <th>Continent</th>
              <th>Country</th>
              <th>Region</th>
              <th>City</th>
            </tr>
          </thead>
          <tbody>
          {activities?.activities?.length === 0 && <tr><td colSpan={5}  className="no-logs-found">No logs found.</td></tr>}
            {activities?.activities?.map((log: any, i: number) => {
              const startTime = new Date(log.dateAndTime);
              const endTime = log.endDateAndTime ? new Date(log.endDateAndTime) : null;
              const duration = calculateTimeDifference(startTime, endTime);
              return (
                <tr key={log._id}>
                  <td>{indexOfFirstLog + i + 1}</td>
                  <td>{log.user_details?.email}</td>
                  <td>{startTime.toLocaleString("en-IN")}</td>
                  <td>{duration}</td>
                  <td>{log.activity_type || "N/A"}</td>
                  <td>{log.client_ip_address}</td>
                  <td>{log?.continent_name || '-'}</td>
                  <td>{log?.country_name || '-'}</td>
                  <td>{log?.region_name || '-'}</td>
                  <td>{log?.city || '-'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="pagination">
        <button
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1 || totalActivities === 0}
        >
          Previous
        </button>

        {/* Render page numbers with ellipses logic */}
        {renderPaginationPages().map((page, index) => {
          if (page === "...") {
            return <span key={index}>...</span>;
          }
          return (
            <button
              key={index}
              onClick={() => paginate(page as number)}
              className={currentPage === page ? "active" : ""}
            >
              {page}
            </button>
          );
        })}

        <button
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages || totalActivities === 0}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default LogsPage;
